import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth";
//LAYOUT COMPONENTS
import Menu from "../../components/comun/Menu/Menu";
import Footer from "../../components/Footer";
import Item from "../../components/comun/Menu/Item";
//OPCIONES
import SeleccionarNomina from "./Opciones/SeleccionarNomina/seleccionarNomina";
import TablaTipoNomina from "./Opciones/TipoNomina/tablaTipoNomina";
import TablaOtrosPagos from "./Opciones/OtrosPagos/tablaOtrosPago";
import SeleccionarOtrosPagos from "./Opciones/SeleccionarOtrosPagos/SeleccionarOtrosPagos";
//ARCHIVOS
import Constantes from "./Archivos/Constantes/Constantes";
import Conceptos from "./Archivos/Conceptop/Conceptos";
import GruposNominas from "./Archivos/GruposNominas/GruposNominas";
import UnidadFuncioanl from "./Archivos/UnidadFuncional/UnidadFuncional";
import Departamentos from "./Archivos/Departamentos/Departamentos";
import Bancos from "./Archivos/Bancos/Bancos";
import Cargos from "./Archivos/Cargos/Cargos";
import Tablas from "./Archivos/Tablas/Tablas";
//TRANSACCIONES
import SeleccionarProcesar from "./Transacciones/ProcesarNominas/seleccionarProcesar";
import RevisarNominas from "./Transacciones/RevisarNominas/RevisarNominas";
import Vacaciones from "./Transacciones/Vacaciones/Vacaciones";
import Liquidaciones from "./Transacciones/Liquidaciones/Liquidaciones";
import PresentacionesAntReg from "./Transacciones/PresentacionesAntReg/PresentacionesAntReg";
import GrabarAcumulados from "./Transacciones/GrabaarAcumulados/GrabarAcumulados";
import OtrosPrestamos from "./Transacciones/OtrosPrestamos/OtrosPrestamos";
import CrearArchivoTxt from "./Transacciones/CrearArchivoTxt/CrearArchivoTxt";
//VARIOS
import Usuarios from "./Varios/Usuarios/Usuarios";
import ReversarGrabarAcumulados from "./Varios/ReversarGrabarAcumulados/ReversarGrabarAcumulados";
import ActualizarAumentosSueldos from "./Varios/ActualizarAumentosSueldos/ActualizarAumentosSueldos";
import ActualizarGradoInstruccion from "./Varios/ActualizarGradiInstruccion/ActualizarGradoInstruccion";
import ActualizarEspecialidad from "./Varios/ActualizarEspecialidad/ActualizarEspecialidad";
import ActualizarMencion from "./Varios/ActualizarMencion/ActualizarMencion";
import ActualizarMontoConceptosVacaciones from "./Varios/ActualizarMontoConceptosVacaciones/ActualizarMontoConceptosVacaciones";
//CONFIGURACION
import Organizacion from "./Configuracion/Organizacion/Organizacion";
import DesconectarUsuarios from "./Configuracion/DesconectarUsuarios/DesconectarUsuarios";
import DesbloquearRegistros from "./Configuracion/DesbloquearRegistros/DesbloquearRegistros";
import Persona from "./Configuracion/Persona/Persona";
import ValorUnidadTributaria from "./Configuracion/ValorUnidadTributaria/ValorUnidadTributaria";
import TasasActivas from "./Configuracion/TasasActiva/TasasActiva";
import TasasPasivas from "./Configuracion/TasasPasivas/TasasPasivas";
//REPORTES
import SolicitudPagoNomina from "./Reportes/SolicitudPagoNomina/SolicitudPagoNomina";
import ReportesNomina from "./Reportes/ReportesNomina/ReportesNomina";
import ReportesGenerales from "./Reportes/ReportesGenerales/ReportesGenerales";
import ReportesVacaciones from "./Reportes/ReportesVacaciones/ReportesVacaciones";
import axios from "axios";
import imgNomina from "../../imagenes/fd_nomina.png";
import TablaIntegrantes from "./Archivos/Integrantes/tablaIntegrantes";
import TablaCargos from "./Archivos/Cargos/tablaCargos";
import TablaBancos from "./Archivos/Bancos/tablaBancos";
import TablaDepartamentos from "./Archivos/Departamentos/tablaDepartamentos";
import TablaUnidadFuncional from "./Archivos/UnidadFuncional/tablaUnidadFuncional";
import TablaGrupoNomina from "./Archivos/GruposNominas/tablaGrupoNomina";
import TablaConceptos from "./Archivos/Conceptop/tablaConcepto";
import TablaConstantes from "./Archivos/Constantes/tablaConstantes";

export default function Nomina() {
	const op = require("../../../src/modulos/datos");
	let token = localStorage.getItem('jwtToken');

	const { user } = useContext(AuthContext);

	const [fechaSistema, setFechaSistema] = useState(
		localStorage.getItem("fechasistema")
	);
	const [show, setShow] = useState(false);
	const [tabla, setTabla] = useState(0);
	const [cambioFecha, setCambioFecha] = useState(true);

	useEffect(() => {
		let obj = JSON.parse(localStorage.getItem("post"));
		setFechaSistema(obj.fechasistema);
		if (obj != null) {
			setFechaSistema(obj.fechasistema);
		}
	}, []);

	const cerrarSeleccionarNomina = (msg) => {
		setShow(false);
		setTabla(0);
		if (msg !== '') {
			setMensaje({
				mostrar: true,
				titulo: "ERROR",
				texto: msg,
				icono: "error",
			});
		}
	};

	const aceptarSeleccionarNomina = () => {
		setShow(false);
		setTabla(0);
		let body = {
			nomusu: JSON.parse(localStorage.getItem("post")).login,
			nomper: JSON.parse(localStorage.getItem('liquidador')),
			fechasis: JSON.parse(localStorage.getItem('fechasistema')),
			codnomi: JSON.parse(localStorage.getItem('codigonomina')),
			titnomi: JSON.parse(localStorage.getItem('titulonomina'))
		};

		actualizarValores(body);
		actualizarConfig();
		activarTrabajadores();
	};

	const actualizarValores = (body) => {
		//setActivate(true);
		let endpoint = `${op.conexion}/api/nomina/actualizarvalores`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				//setActivate(false);
				if (response.status == 200) {

				} else {

				}
				
			})
			.catch(function (error) {
			actualizarConfig	/*setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});*/
				//setActivate(false);
			});
	};

	const actualizarConfig = () => {
		//setActivate(true);
		let endpoint = `${op.conexion}/api/nomina/actualizarconfig/${JSON.parse(localStorage.getItem('codigonomina'))}`;
		axios
			.post(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				//setActivate(false);
				if (response.status == 200) {
					localStorage.setItem('numsemana', response.data.numper);	
				} else {

				}
				
			})
			.catch(function (error) {
				/*setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});*/
				//setActivate(false);
			});
	};

	const activarTrabajadores = () => {

		let body = {
			codnomi: JSON.parse(localStorage.getItem('codigonomina')),
			fechanomi: JSON.parse(localStorage.getItem('fechanomina'))
		};
		
		let endpoint = `${op.conexion}/api/nomina/activartrabajadores`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				//setActivate(false);
				
			})
			.catch(function (error) {
				alert(JSON.stringify(error.response.data.message))
				/*setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});*/
				//setActivate(false);
			});
	};
	
	const opcionesItem = {
		title: "Opciones",
		icon: "fa fa-pen-alt me-2",
		drop: [
			{
				title: "Seleccionar Nomina",
				icon: "fa fa-folder me-2",
				itemClickValue: 1,
			},
			{
				title: "Tipo de Nomina",
				icon: "fa fa-folder me-2",
				itemClickValue: 2,
			},
			{
				title: "Otros Pagos",
				icon: "fa fa-money-bill me-2",
				itemClickValue: 3,
			},
			{
				title: "Seleccionar Otros Pagos",
				icon: "fa fa-money-check  me-2",
				itemClickValue: 4,
			},
		],
	};
	const archivosItem = {
		title: "Archivos",
		icon: "fa fa-folder me-2",
		drop: [
			{
				title: "Configuración de Nomina",
				icon: "fa fa-cog me-2",
				itemClickValue: 5,
			},
			{
				title: "Constantes",
				icon: "fa fa-ruler me-2",
				itemClickValue: 6,
			},
			{
				title: "Conceptos",
				icon: "fa fa-boxes me-2",
				itemClickValue: 7,
			},
			{
				title: "Grupos de Nominas",
				icon: "fa fa-folder  me-2",
				itemClickValue: 8,
			},
			{
				title: "Unidad Funcional",
				icon: "fa fa-file me-2",
				itemClickValue: 9,
			},
			{
				title: "Departamentos",
				icon: "fa fa-building me-2",
				itemClickValue: 10,
			},
			{
				title: "Bancos",
				icon: "fa fa-money-bill  me-2",
				itemClickValue: 11,
			},
			{
				title: "Cargos",
				icon: "fa fa-user me-2",
				itemClickValue: 12,
			},
			{
				title: "Integrantes",
				icon: "fa fa-users  me-2",
				itemClickValue: 13,
			},
			{
				title: "Tablas",
				icon: "fa fa-table  me-2",
				itemClickValue: 14,
			},
		],
	};
	const transaccionesItem = {
		title: "Transacciones",
		icon: "fa fa-money-bill me-2",
		drop: [
			{
				title: "Procesar Nominas",
				icon: "fa fa-cog me-2",
				itemClickValue: 15,
			},
			{
				title: "Revisar Nominas",
				icon: "fa fa-search me-2",
				itemClickValue: 16,
			},
			{
				title: "Vacaciones",
				icon: "fa fa-home me-2",
				itemClickValue: 17,
			},
			{
				title: "Adelanto s Vacaciones",
				icon: "fa fa-money-bill me-2",
				itemClickValue: 18,
			},
			{
				title: "Liquidación",
				icon: "fa fa-chart-pie me-2",
				itemClickValue: 19,
			},
			{
				title: "Presentaciones Ant. Reg.",
				icon: "fa fa-file me-2",
				itemClickValue: 20,
			},
			{
				title: "Adelantos de Prestaciones",
				icon: "fa fa-money-bill me-2",
				itemClickValue: 21,
			},
			{
				title: "Grabar Acumulados",
				icon: "fa fa-download me-2",
				itemClickValue: 22,
			},
			{
				title: "Generar Períodos",
				icon: "fa fa-calendar me-2",
				itemClickValue: 23,
			},
			{
				title: "Prestaciones",
				icon: "fa fa-pen me-2",
				itemClickValue: 24,
			},
			{
				title: "Otros Prestamos",
				icon: "fa fa-landmark me-2",
				itemClickValue: 25,
			},
			{
				title: "Crear archivo TXT",
				icon: "fa fa-download me-2",
				itemClickValue: 26,
			},
		],
	};
	const variosItem = {
		title: "Varios",
		icon: "fa fa-bars me-2",
		drop: [
			{
				title: "Fecha y Num. Período Mes",
				icon: "fa fa-calendar me-2",
				itemClickValue: 27,
			},
			{
				title: "Copiar Conceptos y Trabajadores",
				icon: "fa fa-copy me-2",
				itemClickValue: 28,
			},
			{
				title: "Usuarios",
				icon: "fa fa-users me-2",
				itemClickValue: 29,
			},
			{
				title: "Actualizar Días Feriados",
				icon: "fa fa-edit me-2",
				itemClickValue: 30,
			},
			{
				title: "Reversar Grabar Acumulados",
				icon: "fa fa-money-check me-2",
				itemClickValue: 31,
			},
			{
				title: "Actualizar Aumentos De Sueldos",
				icon: "fa fa-edit me-2",
				itemClickValue: 32,
			},
			{
				title: "Actualizar Grado de Instrucción",
				icon: "fa fa-edit me-2",
				itemClickValue: 33,
			},
			{
				title: "Actualizar Especialidad",
				icon: "fa fa-edit me-2",
				itemClickValue: 34,
			},
			{
				title: "Actualizar Mención",
				icon: "fa fa-edit me-2",
				itemClickValue: 35,
			},
			{
				title: "Actualizar Monto Conceptos Vacaciones",
				icon: "fa fa-edit me-2",
				itemClickValue: 36,
			},
		],
	};
	const configuracionItem = {
		title: "Configuración General",
		icon: "fa fa-cog me-2",
		drop: [
			{
				title: "Organización",
				icon: "fa fa-users me-2",
				itemClickValue: 37,
			},
			{
				title: "Desconectar Usuarios",
				icon: "fa fa-plug me-2",
				itemClickValue: 38,
			},
			{
				title: "Desbloquear Registros",
				icon: "fa fa-lock me-2",
				itemClickValue: 39,
			},
			{
				title: "Personas",
				icon: "fa fa-user me-2",
				itemClickValue: 40,
			},
			{
				title: "Valor Unidad Tributaria",
				icon: "fa fa-money-bill me-2",
				itemClickValue: 41,
			},
			{
				title: "Tasas Activa",
				icon: "fa fa-money-bill me-2",
				itemClickValue: 42,
			},
			{
				title: "Tasas Pasiva",
				icon: "fa fa-money-bill me-2",
				itemClickValue: 43,
			},
		],
	};
	const reportesItems = {
		title: "Reportes",
		icon: "fa fa-file me-2",
		drop: [
			{
				title: "Reporte Nomina",
				icon: "fa fa-chart-pie me-2",
				itemClickValue: 44,
			},
			{
				title: "Reportes Generales",
				icon: "fa fa-chart-pie me-2",
				itemClickValue: 45,
			},
			{
				title: "Solicitud Pago Nomina",
				icon: "fa fa-chart-pie me-2",
				itemClickValue: 46,
			},
			{
				title: "Reportes de Vacaciones",
				icon: "fa fa-chart-pie me-2",
				itemClickValue: 47,
			},
		],
	}

	 const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgNomina}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };
	const vista = {
		0: <PorDefecto />,
		1: <SeleccionarNomina show={show} llamado={1} onHideCancela={cerrarSeleccionarNomina} onHideAcepta={aceptarSeleccionarNomina} />,
		2: <TablaTipoNomina setTabla={setTabla} setShow={setShow} show={show} />,
		3: <TablaOtrosPagos setTabla={setTabla} setShow={setShow} show={show} />,
		4: <SeleccionarOtrosPagos setTabla={setTabla} setShow={setShow} show={show} onHideCancela={cerrarSeleccionarNomina} onHideAcepta={aceptarSeleccionarNomina} />,
		5: <></>,
		6: <TablaConstantes setTabla={setTabla} setShow={setShow} show={show} />,
		7: <TablaConceptos setTabla={setTabla} setShow={setShow} show={show} />,
		8: <TablaGrupoNomina setTabla={setTabla} setShow={setShow} show={show} />,
		9: <TablaUnidadFuncional setTabla={setTabla} setShow={setShow} show={show} />,
		10: <TablaDepartamentos setTabla={setTabla} setShow={setShow} show={show} />,
		11: <TablaBancos setTabla={setTabla} setShow={setShow} show={show} />,
		12: <TablaCargos setTabla={setTabla} setShow={setShow} show={show} />,
	///	13: <Integrantes setTabla={setTabla} setShow={setShow} show={show} />,
		13: <TablaIntegrantes condicion={"  status != 'I' "} setTabla={setTabla} setShow={setShow} show={show} />,
	
		14: <Tablas setTabla={setTabla} setShow={setShow} show={show} />,
		15: <SeleccionarProcesar setTabla={setTabla} setShow={setShow} show={show} llamado={0} modulo={"PROCESAR"} />,
		16: <RevisarNominas setTabla={setTabla} setShow={setShow} show={show} />,
		17: <Vacaciones setTabla={setTabla} setShow={setShow} show={show} />,
		18: <></>,
		19: <Liquidaciones setTabla={setTabla} setShow={setShow} show={show} />,
		20: (
			<PresentacionesAntReg setTabla={setTabla} setShow={setShow} show={show} />
		),
		21: <></>,
		//22: <GrabarAcumulados setTabla={setTabla} setShow={setShow} show={show} />,
		22: <SeleccionarProcesar setTabla={setTabla} setShow={setShow} show={show} llamado={0} modulo={"GRABAR"} />,
		23: <SeleccionarProcesar setTabla={setTabla} setShow={setShow} show={show} llamado={0} modulo={"GENERAR"} />,
		24: <></>,
		25: <OtrosPrestamos setTabla={setTabla} setShow={setShow} show={show} />,
		26: <CrearArchivoTxt setTabla={setTabla} setShow={setShow} show={show} />,
		27: <></>,
		28: <></>,
		29: <Usuarios setTabla={setTabla} setShow={setShow} show={show} />, //aqui
		30: <></>,
		//31: (<ReversarGrabarAcumulados setTabla={setTabla} setShow={setShow} show={show} />),
		31: <SeleccionarProcesar setTabla={setTabla} setShow={setShow} show={show} llamado={2} modulo={"REVERSAR"} />,
		32: (<ActualizarAumentosSueldos setTabla={setTabla} setShow={setShow} show={show} />),
		33: (
			<ActualizarGradoInstruccion
				setTabla={setTabla}
				setShow={setShow}
				show={show}
			/>
		),
		34: (
			<ActualizarEspecialidad
				setTabla={setTabla}
				setShow={setShow}
				show={show}
			/>
		),
		35: <ActualizarMencion setTabla={setTabla} setShow={setShow} show={show} />,
		36: (
			<ActualizarMontoConceptosVacaciones
				setTabla={setTabla}
				setShow={setShow}
				show={show}
			/>
		),
		37: <Organizacion setTabla={setTabla} setShow={setShow} show={show} />,
		38: (
			<DesconectarUsuarios setTabla={setTabla} setShow={setShow} show={show} />
		),
		39: (
			<DesbloquearRegistros setTabla={setTabla} setShow={setShow} show={show} />
		),
		40: <Persona setTabla={setTabla} setShow={setShow} show={show} />,
		41: <ValorUnidadTributaria setTabla={setTabla} setShow={setShow} show={show} />,
		42: <TasasActivas setTabla={setTabla} setShow={setShow} show={show} />,
		43: <TasasPasivas setTabla={setTabla} setShow={setShow} show={show} />,
		44: <ReportesNomina setTabla={setTabla} setShow={setShow} show={show} />,
		45: <ReportesGenerales setTabla={setTabla} setShow={setShow} show={show} />,
		//46: <SolicitudPagoNomina setTabla={setTabla} setShow={setShow} show={show} />,
		46: <SeleccionarProcesar setTabla={setTabla} setShow={setShow} show={show} llamado={1} modulo={"SOLICITUD"} />,
		47: <ReportesVacaciones setTabla={setTabla} setShow={setShow} show={show} />,
	};

	if (!user) return <></>;

	return (
		<div className="w-100 col-12 m-0 p-0">
			<Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)} llamado={1}>
				<Item item={opcionesItem} setTabla={setTabla} setShow={setShow} />
				<Item item={archivosItem} setTabla={setTabla} setShow={setShow} />
				<Item item={transaccionesItem} setTabla={setTabla} setShow={setShow} />
				<Item item={variosItem} setTabla={setTabla} setShow={setShow} />
				<Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />
				<Item item={reportesItems} setTabla={setTabla} setShow={setShow} />
				<a
					href="/inicio"
					className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
				>
					<i className="fas fa-power-off me-2" />
					Salir
				</a>
			</Menu>
			<section
				className="w-100 col-12 m-0 p-0 d-flex align-items-center justify-content-center"
				style={{ height: "90dvh" }}
			>
				{vista[tabla]}
			</section>
			<Footer />
		</div>
	);
}
